import axios from 'axios';
import connection from './connection';
import { CommonResponse } from'@gtpl/shared-models/masters';
import { AllRmCountPriceListResponse, RmCountPriceListDto, RmCountPriceListRequestDto, RmCountPriceListResponseModel, RmRatesInfoReq } from '@gtpl/shared-models/raw-material-procurement';


export class RmCountPriceListService{
    URL = connection.DEPLOY_URL + '/rm-count-price-list';

    async create (dto:RmCountPriceListRequestDto): Promise<RmCountPriceListResponseModel>{
        return await axios.post(this.URL +'/createRmCountPriceList', dto)
        .then(res=>{
            return res.data
        })
    }

    async update(dto: RmCountPriceListDto): Promise<RmCountPriceListResponseModel> {
        return await axios.post(this.URL + '/updateRmCountPriceList', dto)
            .then(res => {
                return res.data
            })
    }

    async activatedeActivate(Dto: RmCountPriceListDto): Promise<RmCountPriceListResponseModel> {
        return await axios.post(this.URL + '/activateOrDeactivateRmCountPriceList', Dto)
            .then(res => {
                return res.data
            })
    }

    async getAll(): Promise<AllRmCountPriceListResponse> {
        return await axios.post(this.URL + '/getAllRmCountPriceList')
            .then(res => {
                return res.data
            })
    }

    async saveRmCountPricelistInfo(req:RmCountPriceListRequestDto): Promise<AllRmCountPriceListResponse> {
        return await axios.post(this.URL + '/saveRmCountPricelistInfo',req)
            .then(res => {
                return res.data
            })
    }
    async getRmCountPriceListInfo(): Promise<AllRmCountPriceListResponse> {
        return await axios.post(this.URL + '/getRmCountPriceListInfo')
            .then(res => {
                return res.data
            })
    }
    async getRmCountPriceListInfoCount(): Promise<AllRmCountPriceListResponse> {
        return await axios.post(this.URL + '/getRmCountPriceListInfoCount')
            .then(res => {
                return res.data
            })
    }
    async getRmRatesData(): Promise<CommonResponse> {
        return await axios.post(this.URL + '/getRmRatesData')
            .then(res => {
                return res.data
            })
    }
    async getRmPriceDeviation(): Promise<CommonResponse> {
        return await axios.post(this.URL + '/getRmPriceDeviation')
            .then(res => {
                return res.data
            })
    }
    async getRmRatesAqua(): Promise<CommonResponse> {
        return await axios.post(this.URL + '/getRmRatesAqua')
            .then(res => {
                return res.data
            })
    }
    async getRmRatesBmr(): Promise<CommonResponse> {
        return await axios.post(this.URL + '/getRmRatesBmr')
            .then(res => {
                return res.data
            })
    }
    async getRmReportDates(): Promise<CommonResponse> {
        return await axios.post(this.URL + '/getRmReportDates')
            .then(res => {
                return res.data
            })
    }
    async getCompanies(): Promise<CommonResponse> {
        return await axios.post(this.URL + '/getCompanies')
            .then(res => {
                return res.data
            })
    }

    async getRmRatesAgainstUploadedDate(req:RmRatesInfoReq): Promise<CommonResponse> {
        return await axios.post(this.URL + '/getRmRatesAgainstUploadedDate',req)
            .then(res => {
                return res.data
            })
    }

    async getHalfCountRangesInfo(): Promise<CommonResponse> {
        return await axios.post(this.URL + '/getHalfCountRangesInfo')
            .then(res => {
                return res.data
            })
    }

    async getMaxEffectiveDate(req:any): Promise<CommonResponse> {
        return await axios.post(this.URL + '/getMaxEffectiveDate',req)
            .then(res => {
                return res.data
            })
    }
}